import {Action, Selector, State, StateContext} from '@ngxs/store';
import {Injectable} from '@angular/core';
import {Auth} from '../actions/auth.actions';
import {SearchResponse} from '../models/search/search.response.model';
import {SearchRequest} from '../models/search/search.request.model';
import {SearchService} from '../services/search.service';
import {Search} from '../actions/search.actions';
import {tap} from 'rxjs/operators';
import {Observable} from 'rxjs';
import ClearState = Auth.ClearState;
import SearchJobs = Search.SearchJobs;
import ClearSearch = Search.ClearSearch;

export interface SearchStateModel {
  searchResults: SearchResponse | null;
  searchRequest: SearchRequest | null;
}

@State<SearchStateModel>({
  name: 'search',
  defaults: {
    searchResults: null,
    searchRequest: {
      isAndLogicSearch: true,
      alwaysIncludeRefrigerator: false,
      alwaysIncludeEngine: false,
      alwaysIncludeDeliveryNote: false,
      dateIsDateIn: true,
    },
  }
})
@Injectable()
export class SearchState {
  constructor(private searchService: SearchService) {
  }

  @Selector()
  static searchRequest(state: SearchStateModel): SearchRequest {
    return state.searchRequest;
  }

  @Selector()
  static searchResults(state: SearchStateModel): SearchResponse {
    return state.searchResults;
  }

  @Action(SearchJobs)
  searchJobs(ctx: StateContext<SearchStateModel>, action: SearchJobs): Observable<SearchResponse> {
    return this.searchService.searchJobs(action.searchRequest).pipe(tap(res => {
      ctx.patchState({
        searchRequest: action.searchRequest,
        searchResults: res
      });
    }));
  }

  @Action(ClearSearch)
  clearSearch(ctx: StateContext<SearchStateModel>): void {
    ctx.setState({
      searchRequest: {
        isAndLogicSearch: true,
        alwaysIncludeRefrigerator: false,
        alwaysIncludeEngine: false,
        alwaysIncludeDeliveryNote: false,
        dateIsDateIn: true,
      },
      searchResults: null,
    });
  }

  @Action(ClearState)
  clearState(ctx: StateContext<SearchStateModel>): void {
    ctx.setState({
      searchRequest: {
        isAndLogicSearch: true,
        alwaysIncludeRefrigerator: false,
        alwaysIncludeEngine: false,
        alwaysIncludeDeliveryNote: false,
        dateIsDateIn: true,
      },
      searchResults: null,
    });
  }
}
